__turbopack_context__.v({
  "error": "style-module-scss-module__fHtNkG__error",
  "img": "style-module-scss-module__fHtNkG__img",
  "imgWrapper": "style-module-scss-module__fHtNkG__imgWrapper",
  "linear": "style-module-scss-module__fHtNkG__linear",
  "root": "style-module-scss-module__fHtNkG__root",
  "subtitle": "style-module-scss-module__fHtNkG__subtitle",
  "text": "style-module-scss-module__fHtNkG__text",
  "title": "style-module-scss-module__fHtNkG__title",
  "wrapper": "style-module-scss-module__fHtNkG__wrapper",
});
